/**
 * WISHLIST PRINT
 * 
 * module de gestion de l'impression de wishlist
 * via une popin dans
 * la partie PRO de l'espace mon compte
 */
import $ from "jquery";
const utils = require('../utils.js').default;
import { strings } from "../../../../helpers/strings.js";
import { services } from "../../../../helpers/service";
import { dialog } from '../../../../components/dialog.js';
import { captcha } from "../../../../components/captcha.js";
const WLPrint = (() => {

    const POPIN_PRINT_WISHLIST = 'popin-print';
    const POPIN_PRICE = 'popinPrice';
    const DOM_POPIN_PRINT_WISHLIST = `[data-js-dialog-id="${POPIN_PRINT_WISHLIST}"]`;
    const DOM_POPIN_PRINT_WISHLIST_BUTTONS = `${DOM_POPIN_PRINT_WISHLIST} button`;
    const POPIN_PRINT_WISHLIST_WAITING_SERVICE = 'popin-print-waiting-service';
    const DOM_POPIN_PRINT_WISHLIST_WAITING_SERVICE = `[data-js-dialog-id="${POPIN_PRINT_WISHLIST_WAITING_SERVICE}"]`;
    const OPENER_POPIN_PRINT_WISHLIST = `.js-popin-print`;
    
    /**
     * CAPTCHA INIT
     */
    const captchaInit = () => {
        if (typeof captchsitekey != 'undefined') {
            $(`${DOM_POPIN_PRINT_WISHLIST} .g-recaptcha`).each(function (index) {
                var _this = $(this);
                var $grecaptcha_response = _this.children('.g-recaptcha-response');
                let grecaptcha = grecaptcha !== undefined ? grecaptcha : null;
                if (grecaptcha === null) return;
                grecaptcha.ready(function() {
                    grecaptcha.execute(captchsitekey, {action: 'submit'}).then(function(token) {
                        // Add your logic to submit to your backend server here.
                        $grecaptcha_response.val(token);
                        // _this.append('<input type="hidden" id="g-recaptcha-response" class="g-recaptcha-response" value="'+token+'" />')
                        _this.closest('form').find('button[type="submit"]').removeClass('captcha-invalid');
                    });
                });
    
            });
        } else {
            console.error('variable captchsitekey undefined');
        }
    };
    /**
     * GET SELECTED PARAMS
     * 
     * récupération des selectionnées dans le form
     * @param {json} xhrData 
     * @returns {string}
     */
    const getSelectedParams = (xhrData) => {
        return xhrData.filter(function(el) {
            // on vérifie la présence des données et l'activation
            return typeof el.name !== 'undefined' && typeof el.value !== 'undefined' && el.value === 'on'
        }).map(function(el) {
            // on formalise les résultats
            return strings.snakeCase(el.name)
        });
    }
    /**
     * CALL PRINT SERVICE
     * 
     * appel du service de génération du 
     * document d'impression
     * @param {json} xhrData 
     * @returns 
     */
    const callPrintService = async function(xhrData) {
        xhrData.push({ name: 'content', value: window.WL.getWishlistSerialized() });
        xhrData.push({ name: 'e', value: utils.getContext() });
        xhrData.push({ name: 'name', value: window.WL.getWishlistName() });
        xhrData.push({ name: 'redution', value: `${window.WL.getWishlistReduction()}%` });

        dialog.open(POPIN_PRINT_WISHLIST_WAITING_SERVICE);
        $(`${DOM_POPIN_PRINT_WISHLIST_WAITING_SERVICE} .c-loader`).attr('aria-hidden', false);
        $(`${DOM_POPIN_PRINT_WISHLIST_WAITING_SERVICE} .js-icon-validation`).addClass("u-hidden");
        return services.use('wishlistprint', xhrData, false)
            .then((result) => {
                if (result.error !== undefined && result.error === "captchaerror") {
                    utils.dispatchCustomEvent('TEMPLATE_ERROR', {error: result.error });
                } else {
                    utils.debug('WL PRINT', result.datas);   

                    utils.dispatchCustomEvent('TRACKERS_TRANSACTION_SUCCESS', {
                        revenue: utils.getFormatedPrice(window.WL.getWishlistGrandTotal()),
                        coupon: `${window.WL.getWishlistReduction()}%`,
                        list_label: window.WL.getWishlistName(),
                        list_category: utils.getContext(),
                        print_features: getSelectedParams(xhrData).join(','),
                        products: window.WL.getWishlistFlattenProductsTransaction(),
                    });

                    $(`${DOM_POPIN_PRINT_WISHLIST_WAITING_SERVICE} .c-loader`).attr('aria-hidden', true);
                    $(`${DOM_POPIN_PRINT_WISHLIST_WAITING_SERVICE} .js-icon-validation`).removeClass("u-hidden");
                    // if (result.datas.file !== undefined ){
                        if (result.datas.file) {
                            location.href = result.datas.file;
                        } else {
                            utils.download(result.datas.filename, result.datas.content)
                        }
                    // }
                }
            })
            .catch(() => {
                utils.debug('WL PRINT', 'erreur du service');  
                utils.dispatchCustomEvent('TEMPLATE_ERROR', {error: 'erreur du service : wishlistprint' });
                $(`${DOM_POPIN_PRINT_WISHLIST_WAITING_SERVICE} .c-loader`).attr('aria-hidden', true);
                $(`${DOM_POPIN_PRINT_WISHLIST_WAITING_SERVICE} .popin-close`).trigger('close');
            });
    };
    /**
     * INIT (func)
     */
    const init = () => {
        utils.debug('WL PRINT', 'initialisation');  
        let data = {
            name: window.WL.getCurrentWishlist(),
            type: utils.getContext(),
        };
        utils.dispatchCustomEvent('TEMPLATE_POPIN_UPDATE', {popinTargetID: POPIN_PRINT_WISHLIST, data});
        captcha.setCaptchaToken([`#recaptcha5`]);
        //captchaInit();
        $(DOM_POPIN_PRINT_WISHLIST).find('form input[type="checkbox"]').on('change', (event) => {
            const checkbox = $(event.currentTarget);
            checkbox.val(checkbox.is(':checked') ? 'on' : '');
        });
        $(DOM_POPIN_PRINT_WISHLIST_BUTTONS).on('click', (event) => {
            dialog.close(POPIN_PRINT_WISHLIST);
            if (event.currentTarget.id === "submitprint") {
                let xhrData = $(DOM_POPIN_PRINT_WISHLIST).find('form').serializeArray();
                // event DOWNLOAD print WISHLIST
                utils.dispatchCustomEvent('TRACKERS_PRINT_WISHLIST', {
                    options: getSelectedParams(xhrData).join(','),
                    productsCount: window.WL.getProductsQuantityTotal(),
                    grandTotal: utils.getFormatedPrice(window.WL.getWishlistGrandTotal()),
                });
                callPrintService(xhrData);
            }
            event.preventDefault();
            return false;
        });
        $(OPENER_POPIN_PRINT_WISHLIST).on('click', () => {
            let xhrData = $(DOM_POPIN_PRINT_WISHLIST).find('form').serializeArray();
            callPrintService(xhrData);
        });
        dialog.get(POPIN_PRINT_WISHLIST).addEventListener('on.open', (event) => {
            WL.getWishlistFlattenProductsFromList(WL._WL.currentWL).then((products) => {  
                utils.dispatchCustomEvent('TRACKERS_WISHLIST_CHECKOUT_OPEN_POPIN', {
                    listLabel: WL._WL.currentWL,
                    listCategory: utils.getContext(),
                    products
                });
            })
        })
    }
    return {init};
})();
export default WLPrint;